import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const TemplateEmail = {
  List: List,
  Update: Update,
  Create: Create,
  Permission: {
    create: "create:TemplateEmail",
    read: "read:TemplateEmail",
    list: "list:TemplateEmail",
    update: "update:TemplateEmail",
    delete: "delete:TemplateEmail",
  },
};
